export class State {
  name = '';
  description = '';

  constructor(name: string, description: string) {
    this.name = name;
    this.description = description;
  }
}
